/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import TbodyComponent from "./sub-module/TbodyComponent";
import "./index.scss";
import { convertHoursIntoSeconds, convertSecondsToHoursAndMinutes } from "../../../../libs/dateUtils";
import Spinner from "../../../../components/Spinner";
import useRoutineAppointment from "../../store/useRoutineAppointment";
import ButtonNavigatorComponent from "../../../../components/ButtonNavigator";
import IconButton from "../../../../components/IconButton";
import { IconSwitch } from "../../../../icons";
import { orderBy } from "../../../../libs/orderBy";

interface TableProps {
  checkboxSelection: boolean;
  dateFrom?: string;
  dateTo?: string;
  endCutValue?: number;
  selectProject?: boolean;
  details?: boolean;
}

export default function TableComponent({ details, checkboxSelection, dateFrom, dateTo }: TableProps) {
  const { rows, selectProject, columns, page, setPage, selectSize, stateSwitch, setSelectSize, listRender, setRows } = useRoutineAppointment();

  const [needSpinner, setNeedSpinner] = useState(true);
  const [checked, setChecked] = useState(false);
  const [orderSwitch, setOrderSwitch] = useState(true);

  useEffect(() => {
    setNeedSpinner(true);
    setTimeout(() => {
      setNeedSpinner(false);
    }, 500);
  }, [listRender, orderSwitch, stateSwitch]);

  function calculateTotalHoursByProject(): string {
    let amount = 0;
    rows?.forEach((element: any) => {
      amount = amount + convertHoursIntoSeconds(element.workedTime || element.timeWorked);
    });
    return convertSecondsToHoursAndMinutes(amount).toString();
  }

  function handleOrderList(label: string) {
    orderSwitch ? setRows(orderBy(listRender, label, "desc")) : setRows(orderBy(listRender, label, "asc"));
    setOrderSwitch((oldState) => !oldState);
    setPage(0);
  }

  return (
    <>
      <div className="tableContainer table-container-full">
        <Spinner className="spinner" status={needSpinner}>
          <table className="table-container-header-body">
            <thead>
              <tr>
                {checkboxSelection && (
                  <th className="checkboxRow">
                    <input className="checkboxInput" checked={checked} type="checkbox" onChange={() => setChecked((checked) => !checked)} />
                  </th>
                )}
                {columns?.map((col: any, index: number) => {
                  return (
                    <th
                      key={index}
                      style={{
                        maxWidth: col.width || `${100 / columns?.length}%`,
                      }}
                      className={`${col.field === "projectName" && "invisible-850px"}`}
                    >
                      <div className="wrapperTheader">
                        <span>{col.headerName}</span>
                        <IconButton icon={IconSwitch} onClick={() => handleOrderList(col.field)} />
                      </div>
                    </th>
                  );
                })}
                {details && <th className="col-function">Detalhes</th>}
              </tr>
            </thead>
            <TbodyComponent details={details} dateFrom={dateFrom} dateTo={dateTo} checkedAll={checked} checkboxSelection={checkboxSelection} />
          </table>
          <div className={`tableNavigatorConatiner navigator-container ${selectProject && "totalHours"}`}>
            {selectProject && <h1>Total de horas do Projeto: {calculateTotalHoursByProject()}</h1>}
          </div>
        </Spinner>
      </div>
      {listRender?.length ? (
        <ButtonNavigatorComponent
          className="ButtonNavigatorCollaborator"
          page={page}
          setPage={setPage}
          selectSize={selectSize}
          setSelectSize={setSelectSize}
          list={listRender}
        />
      ) : (
        ""
      )}
    </>
  );
}
